export const PAYMENT_METHOD_KEYS = {
    CASH: "cash",
    CARD: "card",
    SEND_LINK: "send_link",
};

export const PAYMENT_METHOD_VALUES = {
    CASH: "cash",
    STRIPE: "stripe",
    CARDKNOX: "cardknox",
    SEND_LINK: "send_link",
};
